import { useState, useEffect } from 'react';
export var useIsMobileDevice = function () {
    var _a = useState(undefined), isMobile = _a[0], setIsMobile = _a[1];
    useEffect(function () {
        var userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
        var mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
        setIsMobile(mobile);
    }, []);
    return isMobile;
};
